/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCompanyRequest
 */
export interface GetCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof GetCompanyRequest
     */
    companyId: string;
}

export function GetCompanyRequestFromJSON(json: any): GetCompanyRequest {
    return GetCompanyRequestFromJSONTyped(json, false);
}

export function GetCompanyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompanyRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
    };
}

export function GetCompanyRequestToJSON(value?: GetCompanyRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_id': value.companyId,
    };
}


